module.exports = __webpack_public_path__ + "static/map-ecuador-837acba5677c28a7a1986c3bb0bd65b6.png";